/* eslint-disable-no-else-return */
import { Component } from 'react';
import {connect} from 'react-redux';
import {Navigate} from 'react-router-dom';
import withRouter from '../../../hoc/withRouter';
import Can, {checkPermission} from '../../common/guards/can';
import Footer from '../../footer';

import {footerLinksForRepLayout} from '../../../data/footerLinks';
import {check as loggedIn, storedOriginalUserGroup} from '../../../utils/tokenUtils';
import {REP_USER_GROUPS} from '../../../data/userGroups';
import {isAdminLoggedIn, isRepLoggedIn} from '../../../utils/sessionAreas';
import {USER_TYPE_REP} from '../../../data/userTypes';

import IgniteNavigation from '../ignite-navigation';
import {ACTION_LOGIN, SUBJECT_TEAM_PORTAL} from '../../../data/subjectClasses';

import './rep-layout.css';

class MainLayout extends Component {
  setScrolling = () => (this.props.viewConfig.lockSroll ? 'noscroll' : '');

  render() {
    if (loggedIn() && !isRepLoggedIn() && !checkPermission('login', 'team_portal')) {
      if (isAdminLoggedIn()) {
        return <Navigate to="/admin" replace/>;
      }

      return <Navigate to="/team/login" replace/>;
    }

    const {
      component: RenderComponent, action, subjectClass, private: privateRoute, viewConfig,
      match, location, history
    } = this.props;
    const matchProps = { match, location, history };

    const { setScrolling } = this;

    if (privateRoute && !loggedIn()) {
      const originalUserGroup = storedOriginalUserGroup();
      let path = '/team/login';

      if (originalUserGroup !== undefined) {
        path = REP_USER_GROUPS.includes(originalUserGroup) ? '/team/login' : '/admin/login';
      }

      return <Navigate to={path} replace/>;
    }

    return (
      <Can action={ACTION_LOGIN} subjectClass={SUBJECT_TEAM_PORTAL} cannot={<Navigate to="/team/login" replace/>}>
        <div className='rep-layout'>
          <div id="top-bg-container" />
          <div id="bottom-bg-container" />
          <Can action={action} subjectClass={subjectClass} cannot={<Navigate to="/team/my-profile" replace/>}>
            <div className={setScrolling}>
              <div className='content-wrapper'>

                <IgniteNavigation type={USER_TYPE_REP} igniteLogoLink={viewConfig.isRep ? '/team' : '/team/my-profile'}/>

                <RenderComponent {...matchProps} area={USER_TYPE_REP}/>

                <Footer links={footerLinksForRepLayout}/>
              </div>
            </div>
          </Can>
        </div>
      </Can>
    );
  }
}

const mapStateToProps = state => ({
  viewConfig: state.viewConfig,
});

export default withRouter(connect(mapStateToProps)(MainLayout));
